export default __webpack_public_path__ + "static/media/kanit-regular.a04a68c9.ttf";